import {ErrorHandler, Injectable} from '@angular/core';
import {LogService} from '../services/log.service';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  private static readonly DUPLICATE_ERROR_WINDOW_MS = 10000;
  private static readonly MAX_ERROR_REPORTS_PER_MINUTE = 10;
  private recentErrorReports = new Map<string, number>();
  private errorReportWindowStartedAt = 0;
  private errorReportCount = 0;

  constructor(private logger: LogService) {
  }

  handleError(error) {
    console.log("Footballer.zone caught the following error:");
    console.log(error);

    if (!this.shouldReportError(error)) {
      return;
    }

    this.logger.log("\nError: " + error + "\n, Stacktrace: " + error.stack + " page: " + window.location.href);
  }

  private shouldReportError(error): boolean {
    const now = Date.now();
    if (now - this.errorReportWindowStartedAt > 60000) {
      this.errorReportWindowStartedAt = now;
      this.errorReportCount = 0;
    }

    if (this.errorReportCount >= CustomErrorHandler.MAX_ERROR_REPORTS_PER_MINUTE) {
      return false;
    }

    const fingerprint = this.errorFingerprint(error);
    const lastReportedAt = this.recentErrorReports.get(fingerprint);
    if (lastReportedAt && now - lastReportedAt < CustomErrorHandler.DUPLICATE_ERROR_WINDOW_MS) {
      return false;
    }

    this.recentErrorReports.set(fingerprint, now);
    this.errorReportCount++;
    this.pruneRecentErrorReports(now);
    return true;
  }

  private errorFingerprint(error): string {
    const message = String(error && (error.message || error.toString && error.toString()) || error || "")
      .replace(/Previous value: '[^']*'\\. Current value: '[^']*'\\./g, "Previous/current value changed.")
      .replace(/\\d+(\\.\\d+)?/g, "#");
    const stack = String(error && error.stack || "")
      .split("\n")
      .slice(0, 5)
      .map((line) => line.replace(/:\\d+:\\d+/g, ":#:#"))
      .join("\n");

    return `${message}\n${stack}\n${window.location.pathname}`;
  }

  private pruneRecentErrorReports(now: number): void {
    this.recentErrorReports.forEach((reportedAt, fingerprint) => {
      if (now - reportedAt > CustomErrorHandler.DUPLICATE_ERROR_WINDOW_MS) {
        this.recentErrorReports.delete(fingerprint);
      }
    });
  }
}
